
import React, { useState } from 'react';
import { NavBar } from 'antd-mobile'

import { 
    BodyView,
    InputView,
    ButtonView
} from "../../factory/ViewUtil";
import { ToastContent, ToastLoading, ToastClear } from '../../factory/FactoryUtil';
import { UpdateUserInfo, updateCacheUserinfoName } from '../../../NetworkFactory';


const MeEditNameViewController = ({goback, user}) => {

    const old = user.name
    const [name, setName] = useState(user.name || '')
    const postUpdate = () => {
        if (name.length < 1 || name.length > 20) {
            ToastContent('Valid name length 2-20')
        }
        else if(old === name) {
            ToastContent('The current name cannot be the same as the new one')
        }
        else {
            ToastLoading('Updating...')
            const result = UpdateUserInfo(null, name)
            if(result === undefined) {
                ToastClear()
            }
            else {
                result.then(() => {
                    updateCacheUserinfoName(name)
                    ToastContent('Success')
                    goback()
                }).catch(() => {
                    ToastClear()
                })
            }
        }
    }
    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>Edit Name</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <div style={{height : '20px'}}></div>
               <InputView value={name} onChange={val => {setName(val)}} clearable title = 'Your Name'/>
               <ButtonView onClick={postUpdate} style = {{width : '100%', marginTop : '15px'}}>Update</ButtonView>
            </BodyView>
        </>
    );
}
export default React.memo(MeEditNameViewController)